import { RenameButton } from "@/components/RenameButton";
import { useAuth } from "@/features/auth/AuthContext";
import { renomearDevice } from "../api";

export function DeviceRenameButton({ deviceId, nomeFantasia, onSaved }: {
  deviceId: string; nomeFantasia?: string | null; onSaved?: () => void;
}) {
  const { permissoes } = useAuth();
  if (!permissoes.gerenciarDispositivos) return null;
  return <RenameButton key={deviceId} label="Renomear dispositivo" value={nomeFantasia ?? ""} allowEmpty
    help="O código MQTT não muda. Deixe vazio para remover o nome personalizado."
    onSave={async (name) => {
      await renomearDevice(deviceId, name || null);
      window.dispatchEvent(new Event("ghm:devices-updated"));
      onSaved?.();
    }} />;
}
